import http from './http'

export function getVendorProfile() {
  return http.get('/api/vendor/profile')
}

export function updateVendorProfile(data) {
  return http.put('/api/vendor/profile', data)
}

export function getVendorSegments() {
  return http.get('/api/vendor/segments')
}

export function createVendorSegment(data) {
  return http.post('/api/vendor/segments', data)
}

export function updateVendorSegment(id, data) {
  return http.put(`/api/vendor/segments/${id}`, data)
}

export function changeVendorPassword(data) {
  return http.post('/api/vendor/change-password', data)
}

export function issueSingle(data) {
  return http.post('/api/vendor/issue-single', data)
}

export function issueBatch(data) {
  return http.post('/api/vendor/issue-batch', data)
}

export function getMySNs() {
  return http.get('/api/vendor/sn-codes')
}

export function disableMySN(id) {
  return http.post(`/api/vendor/sn-codes/${id}/disable`)
}

export function getExportUrl() {
  return '/api/vendor/sn-codes/export'
}
